//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { onMounted, useRouter } from "@nuxtjs/composition-api";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";

export default {
  name: "ErrorLayout",
  components: { SfButton, SfHeading },
  props: ["error"],
  setup() {
    const router = useRouter();
    onMounted(() => {
      analyticsEvents.pageError(error.statusCode === 404 ? 404 : 500);
    });
    return {
      router,
    };
  },
};
